import { defineAction } from '~/prix'
import { z } from 'zod'
import machineServiceFetchAction from './machineServiceFetch.action.json' with { type: 'json' }
import { machineServiceObject } from '../machineServiceObject'

const machineServiceFetchDefinition = defineAction({
  ...machineServiceFetchAction,

  input: z.object({
    id: z.string().uuid(),
  }),
  output: machineServiceObject,
})

export default machineServiceFetchDefinition
